import type { SVGProps } from 'react';

export function RocketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.063 15.087q1.262-.012 2.137.863.874.875.863 2.137-.014 1.263-.888 2.138-1.2 1.2-2.838 1.425l-3.287.45.45-3.287q.225-1.638 1.425-2.838.875-.875 2.138-.888" />
      <path d="M15.112 3.475q2.613-1.1 5.363-.9.2.025.4.113a1.13 1.13 0 0 1 .587.587q.087.2.113.4.2 2.75-.9 5.363-1.1 2.612-3.475 4.987l.5 2.475q.1.501-.05.975-.15.476-.5.825L14 21.45a.98.98 0 0 1-.9.288.9.9 0 0 1-.725-.588l-1.525-3.575L6.575 13.3 3 11.775a.92.92 0 0 1-.6-.725.95.95 0 0 1 .275-.9L5.825 7q.35-.35.837-.5t.987-.05l2.476.5q2.375-2.376 4.987-3.475m.338 12.026q-.65.45-1.3.812-.651.363-1.35.712L13.625 19l2.1-2.101zm-10.3-4.976 1.95.825q.35-.699.725-1.35.375-.65.824-1.3L7.25 8.425zm9.925-3.45q-.85 0-1.426.575a1.92 1.92 0 0 0-.574 1.413q0 .837.574 1.412.576.575 1.426.575t1.425-.575a1.92 1.92 0 0 0 .575-1.412q0-.838-.575-1.413t-1.425-.575" />
    </svg>
  );
}
